import React, { Component } from "react"
import "./Modal.css"
import onClickOutside from "react-onclickoutside"
import { IoMdClose } from "react-icons/io"

import work_screenshot_1 from "../../../images/full-stack-project-42-1.png"
import work_screenshot_2 from "../../../images/full-stack-project-42-2.png"
// import { Button } from "semantic-ui-react"
// import "semantic-ui-css/semantic.min.css"

export default class Modal extends Component {
  render() {
    return (
      <div style={{ zIndex: 2 }}>
        <div className="modal" data-status={this.props.status}>
          <div
            className="modal-left"
            style={{ backgroundImage: `url(${this.props.image})` }}
          />
          <div className="modal-right">
            <h2 className="modal_title">{this.props.title}</h2>
            <b className="modal_technologies">{this.props.technologies}</b>
            <p className="modal_description">{this.props.description}</p>

            <a className="visit_site_btn" href={this.props.link}>
              {this.props.button_words}
            </a>

            <button onClick={this.props.onClick} className="close">
              <IoMdClose size="2.5em" />
            </button>
          </div>
        </div>
      </div>
    )
  }
}

Modal.defaultProps = {
  title: "Lorem Ipsum",
  technologies: "Lorem ● Ipsum ● Other ● Lorem ● Hipster",
  description:
    "From formula to fruits, your baby's got a lot of eating ahead. An Ova high chair is the right place for breakfast, lunch and dinner. From formula to fruits, your baby's got a lot of eating ahead. An Ova high chair is the right place for breakfast, lunch and dinner. From formula to fruits, your baby's got a lot of eating ahead. An Ova high chair is the right place for breakfast, lunch and dinner.",
}
